<template>
  <b-button pill no-shadow class="close-button" @click="$emit('click')">
    <svg
      class="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10.5 10.5"
      style="enable-background: new 0 0 10.5 10.5"
      xml:space="preserve"
    >
      <rect
        x="4.2"
        y="-0.8"
        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.1792 5.2215)"
        fill="currentColor"
        width="2"
        height="12"
      />
      <rect
        x="-0.8"
        y="4.2"
        transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.1792 5.2215)"
        fill="currentColor"
        width="12"
        height="2"
      />
    </svg>
    <slot />
  </b-button>
</template>

<script>
export default {
  name: 'SoCloseButton',
}
</script>

<style lang="scss" scoped>
.close-button {
  padding: 6px 18px;
  border-color: #e5e5e5;
  border-radius: 100px;
  background-color: #e5e5e5;
  font-size: 12px;
  color: #222;
}
.icon {
  width: 8px;
  height: 8px;
  margin: -2px 5px 0 0;
}
</style>
